const filtersArray = [
  {
    title: 'Size',
    html: `
      <ul className="flex flex-col gap-16 m-0 p-0">
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="size-xs" name="XS" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 
            sibling-checked:bg-primary sibling-checked:border-primary'/>
            <span></span>
            <label for="size-xs" className="text-primary cursor-pointer">XS (300)</label>
          </div>
        </li>
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="size-s" name="S" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500'/>
            <span></span>
            <label for="size-s" className="text-primary cursor-pointer">S (300)</label>
          </div>
        </li>
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="size-m" name="M" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500' checked/>
            <span></span>
            <label for="size-m" className="text-primary cursor-pointer">M (300)</label>
          </div>
        </li>
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="size-l" name="L" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500'/>
            <span></span>
            <label for="size-l" className="text-primary cursor-pointer">L (300)</label>
          </div>
        </li>
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="size-xl" name="XL" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500'/>
            <span></span>
            <label for="size-xl" className="text-primary cursor-pointer">XL (300)</label>
          </div>
        </li>
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="size-xxl" name="XXL" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500'/>
            <span></span>
            <label for="size-xxl" className="text-primary cursor-pointer">XXL (300)</label>
          </div>
        </li>
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="size-xxxl" name="XXXL"
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500'/>
            <span></span>
            <label for="size-xxxl" className="text-primary cursor-pointer">XXXL (300)</label>
          </div>
        </li>
      </ul>
    `,
  },
  {
    title: 'Sleeve Length',
    html: `
      <ul className="flex flex-col gap-16 m-0 p-0">
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="sleeve-sleeveless" name="Sleeveless" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500'/>
            <span></span>
            <label for="sleeve-sleeveless" className="text-primary cursor-pointer">Sleeveless (196)</label>
          </div>
        </li>
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="sleeve-long" name="Long Sleeve" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500'/>
            <span></span>
            <label for="sleeve-long" className="text-primary cursor-pointer">Long Sleeve (196)</label>
          </div>
        </li>
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="sleeve-short" name="Short Sleeve" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500' checked/>
            <span></span>
            <label for="sleeve-short" className="text-primary cursor-pointer">Short Sleeve (196)</label>
          </div>
        </li>
      </ul>
    `,
  },
  {
    title: 'Interest',
    html: `
      <ul className="flex flex-col gap-16 m-0 p-0">
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="interest-life" name="Life is Good" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500'/>
            <span></span>
            <label for="interest-life" className="text-primary cursor-pointer">Life is Good (196)</label>
          </div>
        </li>
        <li className="relative list-none">
          <div className="flex items-center h-5 relative">
            <input type="checkbox" id="interest-animals" name="Animals, Pets & Insects" 
            class='w-18 h-18 cursor-pointer rounded focus:ring-indigo-500 sibling-checked:bg-blue-500'/>
            <span></span>
            <label for="interest-animals" className="text-primary cursor-pointer">Animals, Pets & Insects (196)</label>
          </div>
        </li>
      </ul>
    `,
  },
];

export default filtersArray;
